export default __webpack_public_path__ + "static/maintenance-graphic-d0b56e14c320f4450e34d09f6d5ed2a6.svg";